import * as React from 'react';
import { findDOMNode } from 'react-dom';

interface IElementInViewportProps {
  onChange(isVisible: boolean): void;
  horizontal?: boolean;
  children: React.ReactNode;
}

interface IElementInViewportState {
  isVisible: boolean;
}

export class ElementInViewport extends React.Component<IElementInViewportProps, IElementInViewportState> {
  private parentElement: Element | null;

  public constructor(props: IElementInViewportProps) {
    super(props);

    this.state = {
      isVisible: false,
    };

    this.parentElement = null;
  }
  // eslint-disable-next-line react/no-deprecated
  public componentWillUpdate(nextProps: IElementInViewportProps, nextState: IElementInViewportState) {
    if (this.state.isVisible !== nextState.isVisible) {
      this.props.onChange(nextState.isVisible);
    }
  }

  public componentDidMount() {
    if (this.props.horizontal) {
      // eslint-disable-next-line react/no-find-dom-node
      this.parentElement = getParent(findDOMNode(this) as Element);

      if (this.parentElement) {
        this.parentElement.addEventListener('resize', this.handleResize);
        this.parentElement.addEventListener('scroll', this.handleResize);
      }
    } else {
      document.addEventListener('resize', this.handleResize);
      document.addEventListener('scroll', this.handleScroll);
    }

    this.setVisibility();
  }

  public componentWillUnmount() {
    if (this.parentElement) {
      this.parentElement.removeEventListener('resize', this.handleResize);
      this.parentElement.removeEventListener('scroll', this.handleResize);
    } else {
      document.removeEventListener('resize', this.handleResize);
      document.removeEventListener('scroll', this.handleScroll);
    }
  }

  public render() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.props.children as any;
  }

  private setVisibility() {
    if (this.state.isVisible) {
      return;
    }
    // eslint-disable-next-line react/no-find-dom-node
    const component = findDOMNode(this) as Element;
    const { top, height, width, right } = component.getBoundingClientRect();

    if (this.props.horizontal) {
      if (!this.parentElement) {
        this.setState({
          isVisible: true,
        });

        return;
      }

      const { width: parentWidth, left: parentLeft } = this.parentElement.getBoundingClientRect();
      const offset = parentWidth + parentLeft;

      const isVisible = right <= offset && right >= -width;

      if (isVisible !== this.state.isVisible) {
        this.setState({
          isVisible,
        });
      }

      return;
    }

    const offset = Math.max(window.innerHeight - height, 0);

    const isVisible = top <= offset && top >= -height;

    if (isVisible !== this.state.isVisible) {
      this.setState({
        isVisible,
      });
    }
  }

  private handleResize = () => {
    this.setVisibility();
  };

  private handleScroll = () => {
    this.setVisibility();
  };
}

function getParent(element: Element): Element | null {
  const parent = element.parentElement;

  if (!parent) {
    return null;
  }

  const { width: elementWidth } = element.getBoundingClientRect();
  const { width: parentWidth } = parent.getBoundingClientRect() || {};

  // Считаем, что для определения контейнера со скроллом достаточно превышения ширины в 1.5 раза
  if (parentWidth > elementWidth * 1.5) {
    return parent;
  }

  return getParent(parent);
}
